"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchTimeline = fetchTimeline;
exports.onAnnouncementTabUnmount = exports.onAnnouncementTabMount = exports.setLastAnnouncementTS = exports.fetchPaginatedFilteredNotifications = exports.fetchFilteredNotifications = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _keyBy = _interopRequireDefault(require("lodash/keyBy"));

var types = _interopRequireWildcard(require("./actionTypes"));

var _TimelineService = _interopRequireDefault(require("../../service/TimelineService"));

var _SearchService = _interopRequireDefault(require("../../service/SearchService"));

var _store = _interopRequireDefault(require("../store"));

var _PulseUtil = _interopRequireDefault(require("../../util/PulseUtil"));

var _SettingsService = _interopRequireDefault(require("../../service/SettingsService"));

/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
function fetchTimeline() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (
    /*#__PURE__*/
    (0, _asyncToGenerator2.default)(
    /*#__PURE__*/
    _regenerator.default.mark(function _callee() {
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _TimelineService.default.fetchTimeline(_store.default, params);

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))
  );
}
/**
 * Returns the set of data based on the filters selected on notificatins pane.
 *
 * @param requestBody
 * @param pageOffset
 */


var fetchFilteredNotifications = function fetchFilteredNotifications(requestBody, pageOffset) {
  return (
    /*#__PURE__*/
    function () {
      var _ref2 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee2(dispatch) {
        var filteredNotificationsData, notificationsById;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _SearchService.default.fetchNotifications(requestBody, pageOffset);

              case 2:
                filteredNotificationsData = _context2.sent;
                //transform the array into an object with id as the key
                notificationsById = (0, _keyBy.default)(filteredNotificationsData.notifications, function (notification) {
                  return notification.id;
                }); // update the store with filtered notification

                dispatch({
                  type: types.FILTERED_NOTIFICATIONS_FETCHED,
                  payload: {
                    notificationsById: notificationsById,
                    offset: filteredNotificationsData.offset,
                    searchQuery: requestBody
                  }
                });

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }()
  );
};
/* returns the set of data based on the pageoffset received on the scroll of filtered notifications */


exports.fetchFilteredNotifications = fetchFilteredNotifications;

var fetchPaginatedFilteredNotifications = function fetchPaginatedFilteredNotifications(requestBody, pageOffset) {
  return (
    /*#__PURE__*/
    function () {
      var _ref3 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee3(dispatch) {
        var filteredNotificationsData, notificationsById;
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _SearchService.default.fetchNotifications(requestBody, pageOffset);

              case 2:
                filteredNotificationsData = _context3.sent;
                //transform the array into an object with id as the key
                notificationsById = (0, _keyBy.default)(filteredNotificationsData.notifications, function (notification) {
                  return notification.id;
                });
                dispatch({
                  type: types.PAGINATED_FILTEREDNOTIFICATION_FETCHED,
                  payload: {
                    notificationsById: notificationsById,
                    offset: filteredNotificationsData.offset
                  }
                });

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x2) {
        return _ref3.apply(this, arguments);
      };
    }()
  );
};

exports.fetchPaginatedFilteredNotifications = fetchPaginatedFilteredNotifications;

var setLastAnnouncementTS = function setLastAnnouncementTS(newTs) {
  return (
    /*#__PURE__*/
    function () {
      var _ref4 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee4(dispatch) {
        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                dispatch({
                  type: types.SET_LAST_ANNOUNCEMENT_TS,
                  payload: {
                    lastSeenTimestamp: newTs
                  }
                });

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function (_x3) {
        return _ref4.apply(this, arguments);
      };
    }()
  );
};

exports.setLastAnnouncementTS = setLastAnnouncementTS;

var onAnnouncementTabMount = function onAnnouncementTabMount() {
  var setLastTS = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  return (
    /*#__PURE__*/
    function () {
      var _ref5 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee5(dispatch) {
        var lastSeenTimestamp, userSettings;
        return _regenerator.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                lastSeenTimestamp = _PulseUtil.default.getTimeInSeconds();
                _context5.next = 3;
                return _SettingsService.default.getUserSettings();

              case 3:
                userSettings = _context5.sent;
                _context5.t0 = userSettings && userSettings.lastSeenAnnouncementsTimestamp;

                if (!_context5.t0) {
                  _context5.next = 8;
                  break;
                }

                _context5.next = 8;
                return dispatch({
                  type: types.SET_LAST_SEEN_ANNOUNCEMENT_TS,
                  payload: userSettings.lastSeenAnnouncementsTimestamp
                });

              case 8:
                _context5.t1 = setLastTS;

                if (!_context5.t1) {
                  _context5.next = 12;
                  break;
                }

                _context5.next = 12;
                return dispatch({
                  type: types.SET_LAST_ANNOUNCEMENT_TS,
                  payload: {
                    lastSeenTimestamp: lastSeenTimestamp
                  }
                });

              case 12:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      return function (_x4) {
        return _ref5.apply(this, arguments);
      };
    }()
  );
};

exports.onAnnouncementTabMount = onAnnouncementTabMount;

var onAnnouncementTabUnmount = function onAnnouncementTabUnmount() {
  return (
    /*#__PURE__*/
    function () {
      var _ref6 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee6(dispatch) {
        var lastSeenTimestamp;
        return _regenerator.default.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                lastSeenTimestamp = _PulseUtil.default.getTimeInSeconds();
                _context6.next = 3;
                return _SettingsService.default.updateUserSettings({
                  lastSeenAnnouncementsTimestamp: lastSeenTimestamp
                });

              case 3:
                _context6.next = 5;
                return dispatch({
                  type: types.SET_LAST_SEEN_ANNOUNCEMENT_TS,
                  payload: lastSeenTimestamp
                });

              case 5:
                _context6.next = 7;
                return dispatch({
                  type: types.SET_LAST_ANNOUNCEMENT_TS,
                  payload: {
                    lastSeenTimestamp: lastSeenTimestamp
                  }
                });

              case 7:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      return function (_x5) {
        return _ref6.apply(this, arguments);
      };
    }()
  );
};

exports.onAnnouncementTabUnmount = onAnnouncementTabUnmount;